/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Col, Row } from '@coursera/coursera-ui';

import { TrackedA } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/career-plans';

import 'css!./__styles__/SurveyMonkeyBanner';

const styles = {
  SurveyMonkeyBanner: css`
    a {
      color: var(--cds-color-blue-700);
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  `,
};

function SurveyMonkeyBanner() {
  return (
    <Row>
      <Col className="careerPlans-survey">
        <div className="careerPlans-container">
          <section css={styles.SurveyMonkeyBanner} className="rc-SurveyMonkeyBanner">
            <h2 className="survey-title">{_t('Help us improve this page')}</h2>
            <TrackedA
              className="survey-link"
              href="https://www.surveymonkey.com/r/L2DLJHC"
              trackingName="survey-link"
              target="_blank"
            >
              {_t('Click here to give feedback!')}
            </TrackedA>
          </section>
        </div>
      </Col>
    </Row>
  );
}

export default SurveyMonkeyBanner;
